import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isCurrentLanguageRtl } from 'modules/language/selectors/language';

import Icon from '../Icon';
import { tooltipPositions } from '../_constants/tooltipPositions';
import ArrowTooltip from '../ArrowTooltip';

import theme from './HintQuestion.scss';

const HintQuestion = ({
  intl,
  iconName,
  className,
  tooltipTestId,
  tooltipMessage,
  tooltipPlacement,
}) => {
  return (
    <ArrowTooltip
      isRtl={ isCurrentLanguageRtl() }
      title={ typeof tooltipMessage === 'string' ? tooltipMessage : intl.formatMessage(tooltipMessage) }
      testId={ tooltipTestId }
      tooltipPlacement={ tooltipPlacement }
      horizontalOffset={ 20 }
    >
      <div className={ theme.root }>
        <Icon
          className={ classnames(theme.iconContainer, className) }
          name={ iconName }
        />
      </div>
    </ArrowTooltip>
  );
};

HintQuestion.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    locale: PropTypes.string,
  }),
  tooltipMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,

  iconName: PropTypes.string,
  className: PropTypes.string,
  tooltipTestId: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf(Object.keys(tooltipPositions)),
};

HintQuestion.defaultProps = {
  intl: {},
  iconName: 'circle-question',
  className: '',
  tooltipTestId: 'tooltip',
  tooltipPlacement: 'top',
};

export default HintQuestion;
